import { render, staticRenderFns } from "./ContractsTab.vue?vue&type=template&id=01834aba"
import script from "./ContractsTab.vue?vue&type=script&lang=js"
export * from "./ContractsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports